import { onAuthStateChanged, User } from "firebase/auth";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Alert, Inline, Text } from "@seneca/senekit";

import { getFirebaseAuth } from "services/firebase/auth";

import { getUserEmail } from "seneca-common/features/user/state";

import TextPlaceholder from "features/common/components/TextPlaceholder";
import { TopbarPortal } from "features/common/top-bars";

import { shouldHideImpersonationBanner } from "./hideImpersonationBanner";

export default function UserImpersonationAlert() {
  const userEmail = useSelector(getUserEmail);
  const [isSignedInWithCustomToken, setIsSignedInWithCustomToken] =
    useState(false);

  useEffect(() => {
    const auth = getFirebaseAuth();
    const hideBanner = shouldHideImpersonationBanner();
    const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
      const token = await user?.getIdTokenResult().catch(e => e);
      setIsSignedInWithCustomToken(
        token?.signInProvider === "custom" && !hideBanner
      );
    });
    return unsubscribe;
  }, []);

  if (!isSignedInWithCustomToken) return null;

  return (
    <TopbarPortal>
      <Alert tone="warning" iconName="person" justifyContent="center">
        <Inline space="small" alignItems="center">
          <Text>You are currently logged in as </Text>
          <TextPlaceholder
            loading={!userEmail}
            loadingStateDelay={0}
            placeholderWidth="200px"
          >
            <Text dataNoTranslate>{userEmail}</Text>
          </TextPlaceholder>
        </Inline>
      </Alert>
    </TopbarPortal>
  );
}
